import { useSuspenseQuery } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

import { getGovAuthorEvaluationValidationHistoryOptions } from './model/GovAuthorEvaluationValidationModel';

interface GovAuthorEvaluationValidationHistoryProps {
  itemId: Id;
  defaultIsCollapsed?: boolean;
}

export function GovAuthorEvaluationValidationHistory({
  itemId,
  defaultIsCollapsed,
}: GovAuthorEvaluationValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getGovAuthorEvaluationValidationHistoryOptions(itemId));

  return (
    <ValidationHistoryContent
      history={history}
      defaultIsCollapsed={defaultIsCollapsed}
    />
  );
}
